<template>
    <div class="member-login">
        <Header />
        <b-row class="pt-5">
            <b-col cols="12" md="8" lg="4" offset-md="2" offset-lg="4">
                <b-card>
                    <h2 class="text-center">{{ $t('individual_member_login') }}</h2>
                    <hr>

                    <b-form @submit.prevent="login" class="mt-5">
                        <b-form-input :placeholder="$t('phone_no')" v-model="user.phone" class="roundeds mt-3"></b-form-input>
                        <!-- <b-input-group class="mt-3">
                            <template #append>
                                <b-button size="sm" variant="success" class="roundeds ml-1">Get Code</b-button>
                            </template>
                            <b-input placeholder="Enter Verification Code." required class="roundeds"></b-input>
                        </b-input-group> -->
                        <b-button variant="success" type="submit" :disabled="loading" class="py-3 mt-4" block>{{loading ? $t('please_wait') :  $t('register_login')}}</b-button>
                    </b-form>
                
                </b-card>
            </b-col>
        </b-row>

        <b-modal v-model="userModal" :title="$t('account_confirmation')" hide-footer>
            <b-row v-if="getLoggedInUser">
                <b-col cols="12" class="text-center">
                    <h6>{{ $t('is_this_you') }}</h6>
                    <h4 class="mt-3">
                        <b class="text-uppercase">{{getLoggedInUser.lastName}},</b> <b>{{getLoggedInUser.firstName}}</b>
                        <b> {{getLoggedInUser.chineseLastName}} {{getLoggedInUser.chineseFirstName}}</b>
                    </h4>
                </b-col>

                <b-col cols="12" class="mt-5">
                    <b-button variant="success" class="py-3" @click="moveToBooking" block>{{ $t('yes_its_me') }}</b-button>
                    <b-button variant="success" class="py-3" block @click="newMember">{{ $t('no_new_member') }}</b-button>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
import Header from '@/components/Header'
import {mapGetters} from 'vuex'
export default {
    components: {
        Header
    },
    computed: {
        ...mapGetters(['getLoggedInUser'])
    },
    created() {
        this.redirectUser();
    },
    data() {
        return {
            loading: false,
            userModal: false,
            user: {
                phone: null,
            }
        }
    },
    methods: {
        async login() {
            this.loading = true
            this.userModal = false
            const resp = await this.$store.dispatch('loginMember', this.user)
            this.loading = false
            if(resp === 1) {
                this.userModal = true
            }
            else {
                this.$router.push({name: 'NewMember', params: {phone: this.user.phone}})
            }
        },
        newMember() {
            this.logoutUser()
            this.$router.push({name: 'NewMember', params: {phone: this.user.phone}})
        },
        moveToBooking() {
            this.move('/booking')
            //window.location.href = window.location.href.split('member-login')[0]+'booking'
        }
    }
}
</script>